import { AbstractBaseResponse } from "./ForgotPINDialog";
import { BorrowerNotificationType } from "@tlc/ls2pac/dto/BorrowerNotificationType";
import { BorrowerAddress } from "./pages/account/LinkedAccountsPage";

export enum FailureReason {
  Other = "Other",
  Exists = "Exists",
  InUse = "InUse",
  NotFound = "NotFound",
  ValidationFailed = "ValidationFailed",
}

interface BorrowerForObr {
  barcode: string;
  issuingBranch: number;
  responsibleAgencyNumber: number;
  pin: string;
  firstName: string;
  middleName: string;
  lastName: string;
  nameSuffix: string;
  salutation: string;
  dob: Date;
  gender: string;
  emailAddress: string;
  emailAddress2: string;
  emailAddress3: string;
  googleId: string;
  smsPhone: string;
  smsGatewayId: number;
  borrowerAddresses: BorrowerAddress[];
  borrowerFields: Map<number, string>;
  borrowerNotificationType: BorrowerNotificationType;
}

interface ExtendedBaseResponse extends AbstractBaseResponse {
  failureReason: FailureReason;
}
interface AddBorrowerUsingObrResponse extends ExtendedBaseResponse {
  borrower: BorrowerForObr;
  agencyNumber: number;
}

export interface ObrResponse {
  response: AddBorrowerUsingObrResponse;
  responseHTML: string;
}
